import { FaMapMarkedAlt, FaMapSigns } from "react-icons/fa";
import { IoMdFlash as FlashIcon } from "react-icons/io";
import { MdGroup, MdLanguage, MdTimelapse } from "react-icons/md";
import {
  Location,
  LocationTranslation,
  Tag,
} from "../../../../../graphql/operations";
import IconItem from "../../../../Atoms/IconItem";
import styles from "./KeyInformation.module.scss";

function formatDuration(durationInMinutes: number) {
  const durationInHours = durationInMinutes / 60;
  const isExact = durationInMinutes % 60 === 0;
  const formatted = isExact ? durationInHours : durationInHours.toFixed(1);

  return `${formatted} hour`;
}

type KeyInformationProps = {
  duration: number | null;
  isPrivate?: boolean;
  maximumInGroup?: number | null;
  tags: Tag[];
  location: Pick<Location, "id"> & {
    translation: Pick<LocationTranslation, "name">;
    country?: {
      name: string;
    };
  };
};

export default function KeyInformation({
  duration,
  isPrivate,
  maximumInGroup,
  tags,
  location,
}: KeyInformationProps) {
  const groupSizeDescription = isPrivate
    ? "Private tour"
    : maximumInGroup >= 10
      ? `Up to ${maximumInGroup} people`
      : "Small group tour";

  return (
    <div className={styles.DetailProductKey}>
      <ul>
        <li>
          <IconItem icon={<FaMapMarkedAlt />}>
            {location.translation.name}, {location.country?.name}
          </IconItem>
        </li>
        <li>
          <IconItem icon={<MdTimelapse />}>
            {duration ? formatDuration(duration) : formatDuration(0)} tour
          </IconItem>
        </li>
        <li>
          <IconItem icon={<MdGroup />}>{groupSizeDescription}</IconItem>
        </li>
        <li>
          <IconItem icon={<MdLanguage />}>English speaking guide</IconItem>
        </li>
        {tags.length > 0 && (
          <li>
            <IconItem icon={<FaMapSigns />}>
              {tags.map((t, index) => {
                return (
                  <span
                    style={{ display: "inline-block", marginRight: 3 }}
                    key={index}
                  >
                    <a
                      href={`/search?tagIds=${encodeURIComponent(
                        JSON.stringify([t.id]),
                      )}`}
                      target="_blank"
                      style={{ textDecoration: "underline" }}
                    >
                      {t.name}
                    </a>
                    {index < tags.length - 1 ? ", " : ""}
                  </span>
                );
              })}
            </IconItem>
          </li>
        )}
        <li>
          <IconItem icon={<FlashIcon />}>Instant Confirmation</IconItem>
        </li>
      </ul>
    </div>
  );
}
